import moment from 'moment';
import { message } from 'antd';
import {
  OrderInfoParams,
  queryFormDataType,
  RetentionInfoParams,
  OrderTrendParams,
  RightRankType,
  RetentionTableParams,
} from './types';

import { MoreRankType } from './constants';

import {
  fetchOrderInfo,
  fetchRetentionInfo,
  fetchUserInfo,
  fetchOrderTrend,
  fetchOrderBusiness,
  fetchOrderOrderTypes,
  fetchOrderRanks,
  fetchMoreOrderRanks,
  fetchOrderRanksGroupmaster,
  fetchRankEnterprise,
  fetchUserRankGroupmaster,
  fetchUserAccessfunnel,
  fetchUserRetentionDay,
  fetchUserRetentionMonth,
  fetchOverview,
  fetchMerchandiseList,
} from './services';

const model = {
  name: 'coreData',
  state: {
    dataTabsKey: '1', // 切换数据tab
    defaultDreaData: [], // 初始化大区数据
    defaultCityData: [], // 选择的默认多城市用于添加对比项目
    defaultBusinessData: [], // 选择商圈的数据用于添加对比项目
    AreaSelectionText: '全部', //  区域选择展示文案
    BusinessSelectionText: '全部', // 商圈选择文案
    defaultDateSelection: [
      moment().add(-6, 'days').startOf('day'),
      moment().add('days').startOf('day'),
    ], // 订单数据日期选择的时间
    defaultUserDate: [moment().add(-6, 'days').startOf('day'), moment().add('days').startOf('day')], // 用户数据日期选择时间
    defaultGoodsDate: [
      moment().add(-6, 'days').startOf('day'),
      moment().add('days').startOf('day'),
    ], // 商品数据选择时间
    selectAreaFormData: {}, // 公共的查询区域集合
    queryUserFormData: {}, // 用户查询数据集合
    queryOrderFormData: {}, // 订单查询数据集合
    queryGoodsRankForm: {}, // 商品排行查询数据集合
    rightRankData: null, // 排行榜的数据
    rightRankMoreData: null, // 查看更多
    groupMasterRankList: null, // 圈长排名数据
    overview: {
      gmv: {
        gmv: 0,
        validGmv: 0,
        realPayGmv: 0,
      },
      order: {
        submitOrderNum: 0,
        validOrderNum: 0,
        pricePerSku: '',
      },
      platForm: {
        platformValidSubsidyRate: '',
        platformValidSubsidy: '',
        shopValidDiscountsAmount: '',
      },
      uv: {
        uv: '',
        miniAppUserRegNumber: '',
        orderUserNumber: '',
      },
      onTime: {
        fsDeliveryOntimeRate: '',
        fsDeliveryOrderNum: '',
        fsDeliveryTimeoutOrderNum: '',
      },
      evaluate: {
        poorEvaluateRate: '',
        skuPoorEvaluateRate: '',
        logisticsPoorEvaluateRate: '',
      },
    },
    orderTrendData: [], // 订单数据趋势
    selectDateType: '0', // 日期维度类型
    selectDim: '0', // 数据维度
    isCompare: false, // 是否是添加对比项
    businessOrderDistribution: {},
    orderOrderTypesDistribution: {},
    rankEnterpriseData: [], // 企业认证用户排行数据
    rankGroupmasterData: [], // 饭圈用户排行数据
    rankMoreGroupmasterData: [], // 查看更多饭圈用户排行数据
    rankMoreEnterpriseData: [], // 查看更多企业认证用户排行数据
    enterpriseKey: '1',
    groupmasterKey: '1',
    userAccessfunnelData: {
      miniAppUserRegNumber: 0,
      merchantListPageUserNumber: 0,
      orderSubmitPageVisNumber: 0,
      submitBtClickUserNumber: 0,
    }, // 用户访问漏斗数据
    retentionData: {
      cumulativeRegUserNum: 0,
      cumulativeOrderNum: 0,
      lastMonthRetainedUserNum: 0,
      lastMonthRetainedUserRate: '',
    }, // 用户留存数据
    useInfoData: {
      miniAppUserRegNumber: 0,
      newUserVisNumber: 0,
      newRegUserNumber: 0,
      reorderUserRate: '',
      newusernum: 0,
      orderedusernum: 0,
      reorderusernumber: 0,
    }, // 用户数据看板
    goodsInfoData: {}, // 商品数据基础数据
    goodsRankTable: [], // 商品数据排行数据
    goodsRankTableLoading: false, // 加载中
    goodsRankTableTotal: 0,
    selectedBigRegion: '',
    selectedRegion: '',
    selectedCity: '',
    selectedBusinessDistrictId: '',
    selectedBusinessType: '',
    lineData: [], // 数据趋势数据
    rightRankMoreModalVisible: false, // 查看更多弹窗
    rightRankMoreType: RightRankType.cityList,
    groupMasterRankListMoreModalVisible: false,
    userDataRankListMoreModalVisible: false,
    userRankMoreType: '',
    dayPageParams: {
      page: 1,
      pageSize: 10,
    }, // 日留存分页
    monthPageParams: {
      page: 1,
      pageSize: 10,
    }, // 月留存分页
    goodsParams: {
      pageNum: 1,
      pageSize: 10,
    },

    retentionDayList: [],
    retentionDayTotal: 0,
    retentionDayDate: [
      moment().subtract(1, 'months'), // 当前时间往前推一个月的时间
      moment(),
    ],
    retentionMonthList: [],
    retentionMonthTotal: 0,
    retentionMonthDate: [
      moment().subtract(6, 'months'), // 当前时间往前推六个月的时间
      moment(),
    ],
    dayTableLoading: true,
    monthTableLoading: true,
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { coreData }, getState }: any) => ({
    setDataTabsKey(payload: string) {
      coreData.setState({
        dataTabsKey: payload,
      });
    },
    setDefaultCityData(payload: string) {
      coreData.setState({
        defaultCityData: payload,
      });
    },
    setDefaultBusinessData(payload: string) {
      coreData.setState({
        defaultBusinessData: payload,
      });
    },

    // 排行列表分页
    changeGoodsPageParams(pageNum, pageSize) {
      coreData.setState({ goodsParams: { pageNum, pageSize } });
      coreData.getGoodsRankData();
    },

    // 订单列表分页
    changeDayPageParams(page, pageSize) {
      coreData.setState({ dayPageParams: { page, pageSize } });
      coreData.getUserRetentionDay();
    },

    changeMonthPageParams(page, pageSize) {
      coreData.setState({ monthPageParams: { page, pageSize } });
      coreData.getUserRetentionMonth();
    },

    // 设置留存搜索的日期
    setRetentionDayDate: (payload: any) => {
      coreData.setState({
        retentionDayDate: payload,
      });
    },
    setRetentionMonthDate: (payload: any) => {
      coreData.setState({
        retentionMonthDate: payload,
      });
    },

    setSelectAreaFormData: (payload: queryFormDataType) => {
      coreData.setState({
        selectAreaFormData: payload,
      });
    },
    setUserQueryFormData: (payload: queryFormDataType) => {
      coreData.setState({
        queryUserFormData: payload,
      });
    },
    setOrderFormData: (payload: queryFormDataType) => {
      coreData.setState({
        queryOrderFormData: payload,
      });
    },
    // 排行榜表单
    setQueryGoodsRankForm: (payload) => {
      const { queryGoodsRankForm } = getState().coreData;
      coreData.setState({
        queryGoodsRankForm: { ...queryGoodsRankForm, ...payload },
      });
    },
    // setOverview: (payload: Overview) => {
    //   coreData.setState({
    //     overview: payload,
    //   });
    // },
    setSelectedBigRegion: (payload: string) => {
      coreData.setState({
        selectedBigRegion: payload,
      });
    },
    setSelectedRegion: (payload: string) => {
      coreData.setState({
        selectedRegion: payload,
      });
    },
    setSelectedCity: (payload: string) => {
      coreData.setState({
        selectedCity: payload,
      });
    },
    setSelectedBusinessDistrictId: (payload: string) => {
      coreData.setState({
        selectedBusinessDistrictId: payload,
      });
    },
    setSelectedBusinessType: (payload: string) => {
      coreData.setState({
        selectedBusinessType: payload,
      });
    },

    setSelectDateType: (payload: string) => {
      coreData.setState({
        selectDateType: payload,
      });
    },
    setSelectDim: (payload: string) => {
      coreData.setState({
        selectDim: payload,
      });
    },
    setIsCompare: (payload: string) => {
      coreData.setState({
        isCompare: payload,
      });
    },
    // 请求订单—数据看板
    async getOrderInfo() {
      const { selectAreaFormData, defaultDateSelection } = getState().coreData;
      const params: OrderInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };
      const data = await fetchOrderInfo(params);
      coreData.setState({
        overview: data,
      });
    },
    // 请求订单-数据趋势
    async getOrderTrend() {
      const { selectAreaFormData, defaultDateSelection, selectDateType, selectDim, isCompare } =
        getState().coreData;
      const params: OrderTrendParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        dateType: selectDateType,
        dim: selectDim,
        isCompare, // 是否是添加对比项
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };
      const data = await fetchOrderTrend(params);
      coreData.setState({
        orderTrendData: data || [],
      });
    },
    // 请求订单-业务分布
    async getOrderBusiness() {
      const { defaultDateSelection, selectAreaFormData } = getState().coreData;
      const params: OrderInfoParams = {
        // bigRegion: queryOrderFormData?.bigRegion,
        // region: queryOrderFormData?.region,
        // city: queryOrderFormData?.city,
        // businessDistrictId: queryOrderFormData?.businessDistrictId,
        // businessType: queryOrderFormData?.businessType,
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };

      const data = await fetchOrderBusiness(params);
      coreData.setState({
        businessOrderDistribution: data,
      });
    },
    //  请求订单-订单类型分布
    async getOrderOrderTypes() {
      const { defaultDateSelection, selectAreaFormData } = getState().coreData;
      const params: OrderInfoParams = {
        // bigRegion: queryOrderFormData?.bigRegion,
        // region: queryOrderFormData?.region,
        // city: queryOrderFormData?.city,
        // businessDistrictId: queryOrderFormData?.businessDistrictId,
        // businessType: queryOrderFormData?.businessType,
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };

      const data = await fetchOrderOrderTypes(params);
      coreData.setState({
        orderOrderTypesDistribution: data,
      });
    },

    // 请求 排行榜
    async getRightRank() {
      const { defaultDateSelection, selectAreaFormData } = getState().coreData;
      const params: OrderInfoParams = {
        // bigRegion: queryOrderFormData?.bigRegion,
        // region: queryOrderFormData?.region,
        // city: queryOrderFormData?.city,
        // businessDistrictId: queryOrderFormData?.businessDistrictId,
        // businessType: queryOrderFormData?.businessType,
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };
      const data = await fetchOrderRanks(params);
      coreData.setState({
        rightRankData: data || [],
      });
    },

    // 圈长排名
    async getOrderRanksGroupmaster(pageSize: number) {
      const { defaultDateSelection, selectAreaFormData } = getState().coreData;
      const params: OrderInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        pageSize,
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };
      const data = await fetchOrderRanksGroupmaster(params);
      coreData.setState({
        groupMasterRankList: data || [],
      });
    },

    // 请求排行榜 类型
    async getRankGroupmaster(pageSize: number) {
      const { defaultDateSelection, rightRankMoreType, selectAreaFormData } = getState().coreData;
      const params: OrderInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        businessType: selectAreaFormData?.businessType,
        startDate: defaultDateSelection[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultDateSelection[1]?.startOf('day').format('YYYY-MM-DD'),
        pageSize,
        replenishType: selectAreaFormData?.replenishType, // 是否补单
      };
      const data = await fetchMoreOrderRanks(MoreRankType[rightRankMoreType], params);
      coreData.setState({
        rightRankMoreData: data,
      });
    },

    // 请求用户-用户留存数据
    async getRetentionInfo() {
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        // bigRegion: queryUserFormData?.bigRegion,
        // region: queryUserFormData?.region,
        // city: queryUserFormData?.city,
        // businessDistrictId: queryUserFormData?.businessDistrictId,
        // companyType: queryUserFormData?.companyType,
        // customerGroupType: queryUserFormData?.customerGroupType,
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
      };
      const data = await fetchRetentionInfo(params);
      coreData.setState({
        retentionData: data,
      });
    },
    // 请求用户-数据看板
    async getUserInfo() {
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
      };
      const data = await fetchUserInfo(params);
      coreData.setState({
        useInfoData: data,
      });
    },
    //用户-企业认证用户排行
    async getRankEnterprise(pageSize, index) {
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
        pageSize,
        index,
      };

      const data = await fetchRankEnterprise(params);
      coreData.setState({
        rankEnterpriseData: data,
      });
    },
    // 查看更多用户-企业认证用户排行
    async getMoreRankEnterprise(pageSize, index) {
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
        pageSize,
        index,
      };

      const data = await fetchRankEnterprise(params);
      coreData.setState({
        rankMoreEnterpriseData: data,
      });
    },

    // 请求用户-饭圈用户排行
    async getUserRankGroupmaster(pageSize, index) {
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
        pageSize,
        index,
      };

      const data = await fetchUserRankGroupmaster(params);
      coreData.setState({
        rankGroupmasterData: data,
      });
    },

    // 查看更多用户-饭圈用户排行
    async getMoreUserRankGroupmaster(pageSize, index) {
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
        pageSize,
        index,
      };

      const data = await fetchUserRankGroupmaster(params);
      coreData.setState({
        rankMoreGroupmasterData: data,
      });
    },

    // 请求用户-用户访问漏斗
    async getUserAccessfunnel() {
      // fetchUserAccessfunnel
      const { defaultUserDate, selectAreaFormData } = getState().coreData;
      const params: RetentionInfoParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        startDate: defaultUserDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: defaultUserDate[1]?.startOf('day').format('YYYY-MM-DD'),
      };
      const data = await fetchUserAccessfunnel(params);
      coreData.setState({
        userAccessfunnelData: data,
      });
    },
    // 请求用户-日留存数据

    async getUserRetentionDay() {
      // dayTableLoading
      coreData.setState({
        dayTableLoading: true,
      });
      const { selectAreaFormData, dayPageParams, retentionDayDate } = getState().coreData;
      const params: RetentionTableParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        ...dayPageParams,
        startDate: retentionDayDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: retentionDayDate[1]?.startOf('day').format('YYYY-MM-DD'),
      };
      const data = await fetchUserRetentionDay(params);
      coreData.setState({
        retentionDayList: data.list,
        retentionDayTotal: data.total,
        dayTableLoading: false,
      });
    },

    // 下载日留存数据
    async downUserRetentionDay() {
      const { selectAreaFormData, dayPageParams, retentionDayDate } = getState().coreData;
      const params: RetentionTableParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        ...dayPageParams,
        startDate: retentionDayDate[0]?.startOf('day').format('YYYY-MM-DD'),
        endDate: retentionDayDate[1]?.startOf('day').format('YYYY-MM-DD'),
        isDownload: 1,
      };
      const data = await fetchUserRetentionDay(params);
      if (data) {
        message.success('下载成功');
      } else {
        message.error('下载失败');
      }
    },

    // 请求月留存数据
    async getUserRetentionMonth() {
      coreData.setState({
        monthTableLoading: true,
      });
      const { selectAreaFormData, monthPageParams, retentionMonthDate } = getState().coreData;
      const params: RetentionTableParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        ...monthPageParams,
        startDate: retentionMonthDate[0]?.startOf('day').format('YYYY-MM'),
        endDate: retentionMonthDate[1]?.startOf('day').format('YYYY-MM'),
      };

      const data = await fetchUserRetentionMonth(params);
      coreData.setState({
        retentionMonthList: data.list,
        retentionMonthTotal: data.total,
        monthTableLoading: false,
      });
    },

    // 下载月留存数据
    async downUserRetentionMonth() {
      const { selectAreaFormData, monthPageParams, retentionMonthDate } = getState().coreData;
      const params: RetentionTableParams = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        companyType: selectAreaFormData?.companyType,
        customerGroupType: selectAreaFormData?.customerGroupType,
        ...monthPageParams,
        startDate: retentionMonthDate[0]?.startOf('day').format('YYYY-MM'),
        endDate: retentionMonthDate[1]?.startOf('day').format('YYYY-MM'),
        isDownload: 1,
      };

      const data = await fetchUserRetentionMonth(params);
      if (data) {
        message.success('下载成功');
      } else {
        message.error('下载失败');
      }
    },

    // 获取商品数据 上架商品数、动销...
    async getGoodsData() {
      const { selectAreaFormData, defaultGoodsDate } = getState().coreData;
      const shopId =
        typeof selectAreaFormData?.shopId?.join === 'function'
          ? selectAreaFormData?.shopId?.join(',')
          : '';
      const subShopId =
        typeof selectAreaFormData?.subShopId?.join === 'function'
          ? selectAreaFormData?.subShopId?.join(',')
          : '';
      const params = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        shopId,
        skuBaseChannel: selectAreaFormData?.skuBaseChannel,
        subShopId,
        startDate: defaultGoodsDate[0]?.startOf('day').format('YYYYMMDD'),
        endDate: defaultGoodsDate[1]?.startOf('day').format('YYYYMMDD'),
        isForm: 0,
      };
      fetchOverview(params).then((data) => {
        coreData.setState({
          goodsInfoData: data,
        });
      });
    },

    // 获取商品排行
    async getGoodsRankData() {
      const { selectAreaFormData, defaultGoodsDate, queryGoodsRankForm, goodsParams } =
        getState().coreData;
      const shopId =
        typeof selectAreaFormData?.shopId?.join === 'function'
          ? selectAreaFormData?.shopId?.join(',')
          : '';
      const subShopId =
        typeof selectAreaFormData?.subShopId?.join === 'function'
          ? selectAreaFormData?.subShopId?.join(',')
          : '';
      const companyId =
        typeof queryGoodsRankForm?.companyId?.join === 'function'
          ? queryGoodsRankForm?.companyId?.join(',')
          : '';
      const params = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        shopId,
        skuBaseChannel: selectAreaFormData?.skuBaseChannel,
        subShopId,
        startDate: defaultGoodsDate[0]?.startOf('day').format('YYYYMMDD'),
        endDate: defaultGoodsDate[1]?.startOf('day').format('YYYYMMDD'),
        businessDirection: queryGoodsRankForm?.businessDirection,
        orderTimeQuantum: queryGoodsRankForm?.orderTimeQuantum,
        orderType: queryGoodsRankForm?.orderType,
        companyId,
        isForm: 0,
        ...goodsParams,
      };
      coreData.setState({
        goodsRankTableLoading: true,
      });
      fetchMerchandiseList(params)
        .then((data) => {
          coreData.setState({
            goodsRankTable: data?.list || [],
            goodsRankTableTotal: data?.total || 0,
          });
        })
        .finally(() => {
          coreData.setState({
            goodsRankTableLoading: false,
          });
        });
    },

    // 下载商品排行数据
    async downGoodsRankData() {
      const { selectAreaFormData, defaultGoodsDate, queryGoodsRankForm, goodsParams } =
        getState().coreData;
      const shopId =
        typeof selectAreaFormData?.shopId?.join === 'function'
          ? selectAreaFormData?.shopId?.join(',')
          : '';
      const subShopId =
        typeof selectAreaFormData?.subShopId?.join === 'function'
          ? selectAreaFormData?.subShopId?.join(',')
          : '';
      const companyId =
        typeof queryGoodsRankForm?.companyId?.join === 'function'
          ? queryGoodsRankForm?.companyId?.join(',')
          : '';
      const params = {
        bigRegion: selectAreaFormData?.bigRegion,
        region: selectAreaFormData?.region,
        city: selectAreaFormData?.city,
        shopId,
        skuBaseChannel: selectAreaFormData?.skuBaseChannel,
        businessDistrictId: selectAreaFormData?.businessDistrictId,
        subShopId,
        startDate: defaultGoodsDate[0]?.startOf('day').format('YYYYMMDD'),
        endDate: defaultGoodsDate[1]?.startOf('day').format('YYYYMMDD'),
        businessDirection: queryGoodsRankForm?.businessDirection,
        orderTimeQuantum: queryGoodsRankForm?.orderTimeQuantum,
        orderType: queryGoodsRankForm?.orderType,
        companyId,
        isForm: 1,
        ...goodsParams,
      };
      const data = await fetchMerchandiseList(params);
      if (data) {
        message.success('下载成功');
      } else {
        message.error('下载失败');
      }
    },

    setDefaultDreaData(payload: string) {
      coreData.setState({
        defaultDreaData: payload,
      });
    },
    setAreaSelectionText(payload: string) {
      coreData.setState({
        AreaSelectionText: payload,
      });
    },
    setBusinessSelectionText(payload: string) {
      coreData.setState({
        BusinessSelectionText: payload,
      });
    },
    setDefaultDateSelection(date: any) {
      coreData.setState({
        defaultDateSelection: date,
      });
    },
    setDefaultUserDate(date: any) {
      coreData.setState({
        defaultUserDate: date,
      });
    },
    setDefaultGoodsDate(date: any) {
      coreData.setState({
        defaultGoodsDate: date,
      });
    },
    setLineData(payload: any) {
      coreData.setState({
        lineData: payload,
      });
    },
    setModalVisible(type: boolean) {
      coreData.setState({
        rightRankMoreModalVisible: type,
      });
    },
    setRightRankMoreType: (payload: string) => {
      coreData.setState({
        rightRankMoreType: payload,
      });
    },
    setGroupMasterRankListMoreModalVisible: (payload: string) => {
      coreData.setState({
        groupMasterRankListMoreModalVisible: payload,
      });
    },
    setUserDataRankListMoreModalVisible: (payload: string) => {
      coreData.setState({
        userDataRankListMoreModalVisible: payload,
      });
    },
    setUserRankMoreType: (payload: string) => {
      coreData.setState({
        userRankMoreType: payload,
      });
    },
    setEnterpriseKey: (payload: string) => {
      coreData.setState({
        enterpriseKey: payload,
      });
    },
    setGroupmasterKey: (payload: string) => {
      coreData.setState({
        groupmasterKey: payload,
      });
    },
  }),
};
export default model;
